import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { useCallback, useContext, useMemo } from 'react';

import { PartnerContact } from '@/components/common/contact_components/PartnerContact';
import { ConfigContext } from '@/Contexts/ConfigContext';
import { LocaleContext } from '@/Contexts/LocaleContext';
import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';
import { ContactProps, ContactType, localizedTextEquals } from '@/models/Contact';

import RowWrap from './IntakeRowWrap';

function IntakeShippingContact() {
  const { contactTypes } = useContext(ConfigContext);
  const { translatedText } = useContext(LocaleContext);

  const {
    shippingContact,
    showErrors,
    shippingSame,
    selectedProgramInfo,
    updateShippingContact,
    updateShippingSame,
  } = useContext(PartnerIntakeContext);

  const shippingContactType = useMemo(
    () =>
      contactTypes.find(
        (c: ContactType) =>
          localizedTextEquals(c.contactTypeName, 'Shipping Address') &&
          c.programId === selectedProgramInfo.id
      ),
    [contactTypes, selectedProgramInfo.id]
  );

  const handleShippingContactChange = useCallback(
    (contact: ContactProps) => {
      updateShippingContact(contact);
    },
    [updateShippingContact]
  );

  const handleShippingSameChange = useCallback(() => {
    updateShippingSame(!shippingSame);
  }, [updateShippingSame, shippingSame]);

  return (
    <>
      <Box display='flex' flexDirection='column' alignItems='left'>
        <Typography style={{ marginTop: '12px', marginBottom: '16px' }} variant='h3'>
          {translatedText.signup.headerShipping}
        </Typography>
      </Box>
      <RowWrap>
        <FormControlLabel
          control={<Checkbox checked={shippingSame} onClick={handleShippingSameChange} />}
          label={translatedText.signup.checkContactShipping}
        />
        <PartnerContact
          id={'partner-shipping-address'}
          contact={shippingContact}
          contactType={shippingContactType}
          onChange={handleShippingContactChange}
          showErrors={showErrors}
        />
      </RowWrap>
    </>
  );
}

export default IntakeShippingContact;
